<template>
  <div id="loginPage">
    <el-row :gutter="0">
      <el-col :span="7" :offset="8">
        <div class="loginFormContent">
          <div style="text-align: center;">
            <h3>欢迎登录</h3>
          </div>
          <div>
            <el-form ref="ruleForm" :model="ruleForm" :rules="rules" status-icon label-position="top" label-width="100px" class="demo-ruleForm" @submit.native.prevent>
              <el-form-item label="账号" prop="username">
                <el-input v-model="ruleForm.username" placeholder="请输入账号" autocomplete="on"></el-input>
              </el-form-item>
              <el-form-item label="密码" prop="password">
                <el-input v-model="ruleForm.password" type="password" placeholder="请输入密码" autocomplete="off" show-password></el-input>
              </el-form-item>
              <!-- <el-form-item label="验证码" prop="captcha">
                <el-col :span="14">
                  <el-input
                    v-model="ruleForm.captcha"
                    placeholder="验证码"
                    auto-complete="on"
                    type="text"
                  />
                </el-col>
                <el-col :span="10">
                  <img :src="captchaPath" class="codeimg" alt="加载失败" @click="getCaptcha()">
                </el-col>
              </el-form-item> -->
              <Verify @success="verifySuccess" mode="pop" captchaType="blockPuzzle" :imgSize="{ width: '330px', height: '155px' }" ref="verify" />
              <el-form-item>
                <el-button type="primary" native-type="submit" style="width: 100%;" @click="submitForm('ruleForm')">登录</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { Encrypt, Decrypt } from '@/utils/crypto'
import { getUUID, isCheckPassword, checkSpecialKey } from '@/utils/index'
import DwAuthorized from '../utils/dw-authorized'
import { msgError } from '../utils/dw-msg'
import { dwLogin, ssologin, getDefault } from '@/api/dw-login'
import { setToken } from '@/utils/auth'
import Verify from './verifition/Verify'

export default {
  name: 'Login',
  components: { Verify },
  data() {
    const validateUsername = (rule, value, callback) => {
      if (value.indexOf(' ') >= 0) {
        callback(new Error('不能含有空格'))
      } else if (value.length > 21) {
        callback(new Error('不能大于20个字符'))
      } else if (!checkSpecialKey(value)) {
        callback(new Error('不能含有特殊字符'))
      } else {
        callback()
      }
    }
    const validatePassword = (rule, value, callback) => {
      if (!isCheckPassword(value)) {
        callback(new Error('请输入8-16位由数字，字母大小写组合'))
        if (value.indexOf(' ') >= 0) {
          callback(new Error('不能含有空格'))
        } else {
          callback()
        }
      } else {
        callback()
      }
    }
    return {
      ruleForm: {
        username: '',
        password: '',
        captcha: '',
        uuid: ''
      },
      captchaPath: '',
      rules: {
        username: [
          { required: true, message: '请输入账号', trigger: 'blur', validator: validateUsername }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur', validator: validatePassword }
        ],
        captcha: [
          { required: true, trigger: 'blur', message: '请输入验证码' }
        ]
      },
      needVerify: true

    }
  },
  created() {
    this.defaultSsologinFn()
    this.getCaptcha()
  },
  mounted() {
    this.pageH = window.height
  },
  methods: {
    verifySuccess(params) {
      // params 返回的二次验证参数, 和登录参数一起回传给登录接口，方便后台进行二次验证
      this.toLogin(params)
    },
    toLogin(data) {
      const params = {
        phone: Encrypt(this.ruleForm.username),
        password: Encrypt(this.ruleForm.password),
        loginType: 'web',
        uuid:localStorage.getItem('slider'),
        captcha:data.captchaVerification,
        // captcha: this.ruleForm.captcha,
        // uuid: this.ruleForm.uuid

      }
      dwLogin(params).then((response) => {
        const resultData = JSON.parse(Decrypt(response.data.data))
        if (response.data.code === 200) {
          this.needVerify = false
          if (resultData.userType === 'teacher' || resultData.userType === 'admin') {
            setToken(resultData.token)
            DwAuthorized.setLocalStore('userinfo', resultData)
            DwAuthorized.setAuthority(resultData.roleKey)
            DwAuthorized.setUserName(resultData.nikeName)
            this.$router.push('/dw/survey/')
          } else {
            msgError('权限不足')
          }
        } else {
          if (resultData.hasOwnProperty('httpResult') && resultData.httpResult != null && resultData.httpResult.hasOwnProperty('resultMsg')) {
            msgError(resultData.httpResult.resultMsg)
          }
        }
      })
    },
    submitForm(formName) {
      // 进行登录验证
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.needVerify) {
            this.$refs.verify.show()
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
    // 获取验证码
    getCaptcha() {
      this.ruleForm.uuid = getUUID()
      this.captchaPath = `${process.env.DW_API_URL}/session/user/v1/captcha.jpg?uuid=${this.ruleForm.uuid}`
    },
    // 单点登录
    defaultSsologinFn() {
      if (this.$route.query.uuid) {
        const params = {
          uuid: this.$route.query.uuid
        }
        ssologin(params).then((response) => {
          const result = response.data
          if (result.code === 200) {
            setToken(result.data)
            getDefault(params).then((response) => {
              const resultData = response.data
              if (resultData.code === 200) {
                resultData.data = JSON.parse(Decrypt(resultData.data))
                if (resultData.data.userType === 'teacher' || resultData.data.userType === 'admin' || 1) {
                  setToken(resultData.data.token)
                  DwAuthorized.setLocalStore('userinfo', resultData.data)
                  DwAuthorized.setAuthority(resultData.data.roleKey)
                  DwAuthorized.setUserName(resultData.data.nikeName)
                  this.$router.push('/dw/survey/')
                } else {
                  msgError('权限不足')
                }
              }
            })
          }
        })
      }
    }
  }
}
</script>

<style scoped>
#loginPage {
  /*background-image: url("http://localhost:8181/diaowen/images/style-model/login_bg/1.jpg");*/
}

.loginFormContent {
  padding: 20px;
  margin-top: 50px;
  background-color: white;
  border: 1px solid gainsboro;
  border-radius: 3px;
}

.codeimg {
  height: 40px;
  width: 90%;
  margin-left: 10%;
  vertical-align: top;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/Login.vue